






import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import BreadcrumbsView, {
  BreadcrumbItem
} from '../../components/Breadcrumbs/BreadcrumbsView.vue'
import PathUtil from '../../modules/util/PathUtil'

const JSON_PATH = PathUtil.makePath('/json/breadcrumbs/breadcrumbs.json')

@Component({
  components: {
    BreadcrumbsView
  }
})
export default class Breadcrumbs extends Vue {
  private items: BreadcrumbItem[]
  private pageId: string

  constructor() {
    super()
    this.items = []
    this.pageId = '0'
  }

  private beforeMount() {
    this.pageId = drupalSettings.vueComponent.contentTop.pageId
  }

  private created() {
    axios
      .get(JSON_PATH)
      .then((response) => {
        const relations = response.data

        // Treeをpage_idから上に辿っていく
        let pid = this.pageId
        this.items = []
        while (relations[pid]) {
          const r = relations[pid]
          this.items.unshift(new BreadcrumbItem(pid, r.l, r.a))
          if (pid === r.p) {
            break
          } else {
            // Prevent infinity loop.
            delete relations[pid]
            pid = r.p
          }
        }
      })
      .catch(() => {
        this.items = []
      })
  }
}
